module.exports = "https://cdn.realtymogul.com/static/media/Icon_check.b78aff82.svg";